import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Button, IconButton, Grid, Box, Divider
} from '@mui/material';
import {
  Close, QrCode2Outlined, GetAppOutlined,
  AndroidOutlined, QrCodeScanner
} from '@mui/icons-material';
import QRCode from "../../../src/assets/qrcode-apk.png";

const ScannerApkModal = ({ open, handleClose }) => {
  const appDownloadURL = "https://passgo.com.ar/api/static/PassGo.apk";

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 2,
          width: '100%',
          maxWidth: { xs: '95%', sm: '80%', md: '600px' }
        }
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        /* bgcolor: '#0b0060', */
        color: '#0b0060',
        fontFamily: "Bricolage Grotesque",
        py: 2
      }}>
        <Box display="flex" alignItems="center" gap={1}>
          <QrCodeScanner />
          <Typography variant="p" sx={{fontSize:"20px"}}>Descarga nuestra app móvil</Typography>
          {/* <Typography variant="subtitle1" color="textSecondary">
            Accede a tu evento, escanea códigos QR y disfruta de una experiencia sin complicaciones con nuestra aplicación móvil.
          </Typography> */}
        </Box>
        <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ py: 3 }}>
        <Typography variant="body1" align="center" gutterBottom color="textSecondary">
          Disfruta de una experiencia sin complicaciones con nuestra aplicación móvil.
        </Typography>

        <Box display="flex" flexDirection="column" alignItems="center" gap={2} mb={2}>
          <p className='mb-0 mt-2'>
            Para descargar, escanea el código QR con tu dispositivo Android.
          </p>
          <img src={QRCode} alt="Código QR para descargar la app" style={{ width: '100%', maxWidth: '200px', margin: '0 auto' }} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <p className='mb-1 mt-1' style={{fontSize:"16px"}}>
            O descarga directamente
          </p>

          <Button
            color="primary"
            size="large"
            href={appDownloadURL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              border: "1px solid #5656FF",
              backgroundColor: "#5656FF",
              color: "white",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: window.innerWidth <= 576 ? "13px" : "14px",
              width: "100%",
              transition: "all 0.3s ease",
              fontWeight: 500,
              '&:hover': {
                color: "white",
                backgroundColor: "#0b0060",
                borderColor: "#0b0060",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              }
            }}
          >
            <GetAppOutlined sx={{ marginRight: "10px" }} /> Descargar Aplicación
          </Button>
          <Typography variant="caption" color="textSecondary">
            Solo disponible para dispositivos Android
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          ¿Cómo funciona?
        </Typography>
        <Box component="ol" sx={{ ml: 2, mt: 1 }}>
          <Typography component="li" variant="body2" paragraph>
            Descarga la aplicación PassGo en tu dispositivo Android.
          </Typography>
          <Typography component="li" variant="body2" paragraph>
            Inicia sesión con tus credenciales de PassGo.
          </Typography>
          <Typography component="li" variant="body2" paragraph>
            Selecciona el evento en el que estás trabajando.
          </Typography>
          <Typography component="li" variant="body2" paragraph>
            Usa la función de escaneo para verificar tickets o vouchers.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Button onClick={handleClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScannerApkModal;